<template>
  <div class="countdown" :class="{ changeColor: changeColor }" v-if="!simple">
    <span :class="{ 'fix-text': !isIOS }">{{ day }}</span>
    <span class="day">天</span>
    <span :class="{ 'fix-text': !isIOS }">{{ hour }}</span>
    <span class="time">:</span>
    <span :class="{ 'fix-text': !isIOS }">{{ minute }}</span>
    <span class="time">:</span>
    <span :class="{ 'fix-text': !isIOS }">{{ second }}</span>
  </div>
  <div v-else class="simple-countDown">
    仅剩{{ day > 0 ? `${day}天` : '' }}{{ hour }}:{{ minute }}:{{ second }}
  </div>
</template>
<script>
let interval = ''
export default {
  props: {
    targetTime: {
      type: Number,
      required: true
    },
    timeOffset: {
      type: Number,
      default: 0
    },
    simple: {
      type: Boolean,
      default: false
    },
    changeColor: {
      type: Boolean,
      default: false
    },
    isIOS: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      day: 0,
      hour: 0,
      minute: 0,
      second: 0
    }
  },
  created() {
    this.calculateRemainingTime()
    interval = window.setInterval(() => {
      this.calculateRemainingTime()
    }, 1000)
  },
  destroyed() {
    interval && window.clearInterval(interval)
  },
  methods: {
    calculateRemainingTime() {
      const endTime = this.targetTime
      const nowTime = Date.now() + this.timeOffset
      const left = (endTime - nowTime) / 1000
      let day = 0,
        hour = 0,
        minute = 0,
        second = 0
      if (left > 0) {
        day = Math.floor(left / (60 * 60 * 24))
        hour = Math.floor(left / (60 * 60)) - day * 24
        minute = Math.floor(left / 60) - day * 24 * 60 - hour * 60
        second =
          Math.floor(left) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        if (day <= 9) {
          day = `0${day}`
        }
        if (hour <= 9) {
          hour = `0${hour}`
        }
        if (minute <= 9) {
          minute = `0${minute}`
        }
        if (second <= 9) {
          second = `0${second}`
        }
        this.day = day
        this.hour = hour
        this.minute = minute
        this.second = second
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/css/mixin';
.countdown {
  height: 100%;
  text-align: center;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  display: inline-block;
  font-size: 0px;
  span {
    font-size: rem(24px);
  }
  .day {
    line-height: 1em;
    font-size: rem(23px);
    margin-right: rem(10px);
  }
  .time {
    line-height: 1em;
  }
}

.fix-text {
  line-height: rem(30px);
}

.simple-countDown {
  font-size: rem(24px);
  color: #999999;
  line-height: rem(24px);
  margin-top: rem(10px);
}
</style>
